import { c } from '../../utils/tailwind-merge';
import { PublisherLists } from '../PublisherLists/PublisherLists';
import { TabsContent, TabsList, TabsRoot, TabsTrigger } from '../Tabs/Tabs';
import { PublisherProfileTabsProps } from './types';

export const PublisherProfileTabs = ({
  renderPublisherAssets,
  lists,
  microcopy,
  value,
  defaultValue,
  className,
}: PublisherProfileTabsProps) => {
  return (
    <section className={c('min-h-116 w-full', className)}>
      <TabsRoot value={value} defaultValue={defaultValue}>
        <TabsList>
          <TabsTrigger value="assets">{microcopy.tabs.assets}</TabsTrigger>
          <TabsTrigger value="lists">{microcopy.tabs.lists}</TabsTrigger>
        </TabsList>

        <TabsContent value="assets" forceMount={true}>
          {renderPublisherAssets()}
        </TabsContent>
        <TabsContent value="lists" forceMount={true}>
          <PublisherLists {...lists} microcopy={{ ...microcopy.lists }} />
        </TabsContent>
      </TabsRoot>
    </section>
  );
};
